var initializeCaptcha = function (captcha) {
    var captchaId = captcha.dataset.id;
    captcha.classList.remove('lazyloading');
    var captchaInput = captcha.querySelector('.cc-recaptcha');
    var errorLabel = captchaInput.dataset.missingError;
    var expireLabel = captchaInput.dataset.expirelabel;
    var siteKey = captchaInput.dataset.key;
    var lang = captchaInput.dataset.lang;

    var verifyCallback = function(response, captchaId) {
        var input = document.querySelector('#cc-captcha-input-' + captchaId);
        var feedback = document.querySelector('#cc-captcha-error-' + captchaId);
        if (response !== undefined) {
            input.setCustomValidity('');
            feedback.classList.add('cc-invisible');
            input.value = response;
        } else {
            input.setCustomValidity(expireLabel);
            feedback.classList.remove('cc-invisible');
            input.value = response;
        }
    };

    grecaptcha.enterprise.render('cc-captcha-anchor-' + captchaId, {
        sitekey: siteKey,
        callback: function(response) {
            return verifyCallback(response, captchaId);
        },
        'expired-callback': function(response) {
            return verifyCallback(response, captchaId);
        },
        hl: lang
    });
    captchaInput.setCustomValidity(errorLabel);
    captchaInput.value = '';
};


const grecaptchaScriptURL = 'https://www.google.com/recaptcha/enterprise.js?onload=onGrecaptchaLoaded&render=explicit';

function checkScriptLoaded(){
    return !! document.querySelector(`script[src="${grecaptchaScriptURL}"]`);
}

function loadScript(loadCallback) {
    document.body.addEventListener('grecaptcha-loaded', function () {
        loadCallback();
    });
    const s = document.createElement('script');
    s.setAttribute('src', grecaptchaScriptURL);
    // s.addEventListener('error', reject);
    document.body.appendChild(s);
}

function initAutoloadCaptchas() {
    var captchas = document.querySelectorAll('.js-captcha-form.auto-lazyloading');
    if (captchas.length) {
        document.body.addEventListener('grecaptcha-loaded', function () {
            captchas.forEach(initializeCaptcha);
        });
    }
}

initAutoloadCaptchas();

document.body.addEventListener('grecaptcha-load', function(e){
    if (! checkScriptLoaded()) {
        loadScript(function(){
            initializeCaptcha(e.detail[0]);
        });
    } else {
        initializeCaptcha(e.detail[0]);
    }
});
